<template>
  <div class="header">
    <div class="container">
      <div class="header-left">
        <a class="header-logo" href="/">
          <img alt="" src="@/assets/logo.webp" />
        </a>
        <a class="header-title" href="/">
          <h1>Actinobacteria TFDB</h1>
        </a>
      </div>
      <div class="header-right">
        <div class="header-nav__list">
          <a
            v-for="nav in navList"
            :key="nav.name"
            :class="[
              { 'header-nav__active': $route.path.startsWith(nav.path) },
            ]"
            class="header-nav__item"
            @click="handleClickNav(nav)"
          >
            {{ nav.name }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { routes } from "@/router";

export default {
  name: "HeaderView",
  data() {
    return {
      navList: routes.filter((route) => {
        if (route.nav) {
          return {
            ...route,
          };
        }
      }),
    };
  },
  methods: {
    handleClickNav(nav) {
      this.$router.push(nav.path);
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  height: px2rem(108);
  user-select: none;

  .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
  }

  .header-left {
    display: flex;
    align-items: center;
  }

  .header-right {
    display: flex;
    align-items: center;
  }

  .header-logo {
    width: px2rem(60);
    height: px2rem(60);
    margin-right: px2rem(20);

    img {
      width: 100%;
      height: 100%;
    }
  }

  .header-title {
    font-weight: bold;

    h1 {
      font-size: px2rem(20);
    }
  }

  .header-nav__list {
    display: flex;
    align-items: center;

    .header-nav__item {
      margin-right: px2rem(50);
      font-weight: bold;
      font-size: px2rem(16);
      cursor: pointer;

      &:nth-last-child(1) {
        margin-right: px2rem(0);
      }

      &:hover {
        color: $--color-primary;
      }

      &.header-nav__active {
        position: relative;
        color: $--color-primary;

        &::after {
          position: absolute;
          bottom: px2rem(-16);
          left: 50%;
          transform: translateX(-50%);
          width: 50%;
          content: "";
          display: block;
          height: px2rem(4);
          border-radius: px2rem(4);
          background-color: $--color-primary;
        }
      }
    }
  }
}
</style>
